import loadable from "@loadable/component";

export const Login = loadable(() => import("./login"), {
  resolveComponent: ({ Login }) => Login,
});

export const Register = loadable(() => import("./register"), {
  resolveComponent: ({ Register }) => Register,
});

export const Dashboard = loadable(() => import("./dashboard"), {
  resolveComponent: ({ Dashboard }) => Dashboard,
});

export const UnlockRecords = loadable(
  () => import("./dashboard/UnlockRecords")
);

export const ChangeUnlockRecords = loadable(
  () => import("./dashboard/ChargeUnlockRecords")
);

export const RegisteredDevices = loadable(
  () => import("./dashboard/RegisteredDevices")
);

export const DeviceUnlockShow = loadable(
  () => import("./dashboard/DeviceUnlockShow")
);

export const PropertiesWithAmazonUnadded = loadable(
  () => import("./dashboard/PropertiesWithAmazonUnadded")
);

export const UnhealthyDevices = loadable(
  () => import("./dashboard/UnhealthyDevices")
);
